module.exports = __webpack_public_path__ + "d74dfd84ad08f922bf8ca61dd02469ac.svg";